// extracted by mini-css-extract-plugin
export default {"container":"BookingManagement_container__1mGk7","sectionTitle":"BookingManagement_sectionTitle__ot-Bi"};